import { writable } from 'svelte/store';

const isBrowser = typeof window !== 'undefined';

const initialConsent = isBrowser ? localStorage.getItem('cookie_consent') : null;

export const cookieConsent = writable(initialConsent);

cookieConsent.subscribe(value => {
    if (isBrowser) {
        if (value === 'true' || value === 'false') {
            localStorage.setItem('cookie_consent', value);
        } else {
            localStorage.removeItem('cookie_consent');
        }
    }
});